import { render, staticRenderFns } from "./areaApplyBase.vue?vue&type=template&id=bfdce20c&scoped=true&"
import script from "./areaApplyBase.vue?vue&type=script&lang=js&"
export * from "./areaApplyBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdce20c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfdce20c')) {
      api.createRecord('bfdce20c', component.options)
    } else {
      api.reload('bfdce20c', component.options)
    }
    module.hot.accept("./areaApplyBase.vue?vue&type=template&id=bfdce20c&scoped=true&", function () {
      api.rerender('bfdce20c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/member/memberAreaApply/areaApplyBase.vue"
export default component.exports